<template>
  <div class="login-page">
    <div class="login-page__background">
      <LoginCard />
    </div>
  </div>
</template>

<script>
import LoginCard from './LoginCard.vue'

export default {
  name: 'LoginPage',
  components: {
    LoginCard
  }
}
</script>

<style scoped src="./assets/index.css" />
